module.exports = __webpack_public_path__ + "static/media/logo_xavier.9017a8d2.png";